import { AlertWidgetContent } from './AlertWidgetContent';
import type { AlertWidgetProps } from './useAlertWidget';

export const AlertWidget = ({ status, hooks }: AlertWidgetProps) => {
  if (status !== 'loaded') {
    return null;
  }

  return <AlertWidgetContent hooks={hooks} />;
};
